// Persists which Templates sub-view (e.g. "Programs") the coach is inside of.
//
// `AllTemplatesView` tracks its active sub-view via `tabView`/`templateView`
// query params that are pushed onto the URL with a plain `history.pushState`
// (so switching tabs doesn't re-fetch already-loaded data). Rill's browser
// adapter never sees that pushState, so it keeps using the URL from the last
// *real* navigation as the `Referrer` for any subsequent `/actions/refresh`
// request (e.g. opening or saving a modal). That referrer lacks `tabView`/
// `templateView`, so the resulting `query` does too - sessionStorage is the
// fallback source of truth for those round trips.
const STORAGE_KEY = "msb:all-templates:active-view";

const getStorage = () => {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch {
    return null;
  }
};

export const readAllTemplatesActiveView = () => {
  const storage = getStorage();
  if (!storage) return null;
  try {
    const raw = storage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const writeAllTemplatesActiveView = (value) => {
  const storage = getStorage();
  if (!storage) return;
  try {
    if (value) storage.setItem(STORAGE_KEY, JSON.stringify(value));
    else storage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore (private browsing / storage disabled).
  }
};

export const clearAllTemplatesActiveView = () =>
  writeAllTemplatesActiveView(null);
